// جای خالی بنر تا داده‌ی آن برسد؛ هر بنر ۴۸ پیکسل (h-12) است تا هدر در لود اولیه نپرد.
export default function BannerSkeleton({ count = 1 }) {
    return (
        <div className="relative w-full">
            {Array.from({ length: count }, (_, index) => (
                <div key={index} className="h-12 w-full bg-jmt-neutral-100" />
            ))}
        </div>
    );
}
